import { colors } from "../variables";
export const styles = {
  passwordContainer: {
    margin: "8px 0",
    padding: 24,
    fontFamily: "Gilroy",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: colors.grayBackground,
  },
  appContainer: {
    fontFamily: "Gilroy",
    margin: "8px 0",
    borderRadius: "4px",
  },
  caveat: {
    marginTop: "12px",
    marginBottom: "12px",
    fontSize: "0.8em",
    color: "rgb(200, 200, 200)",
  },

  instructions: {
    textAlign: "center",
    marginTop: 12,
    marginBottom: 12,
    padding: 24,
    fontSize: "0.9em",
    borderRadius: 4,
    backgroundColor: colors.grayBackground,
  },
  instructionsTitle: {
    fontSize: "1rem",
  },
  stack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    backgroundColor: "#fcc",
    border: "none",
    borderRadius: "5px",
    padding: "8px",
  },
};
